import { useMutation } from '@tanstack/react-query'
import { updateUserContext } from '../../queries/user-context/user-context'
import { PreferencesUpdateProps } from 'types/api'
import { Constants, MethodConstants } from 'constants/constants'
import { useAnalytics } from 'utils/analytics'
import { PreferredMap } from 'types/user-context'

export const useUpdatePreferences = ({
    lanId,
    env,
    accessToken,
    preferences,
}: PreferencesUpdateProps) => {
    const { trackEvent } = useAnalytics()
    const mutation = useMutation({
        retry: false,
        mutationFn: ({
            language,
            preferredMap,
            landingPage,
        }: {
            language: string
            preferredMap?: PreferredMap
            landingPage?: string
        }) => {
            // Merge with existing app_context to preserve values not being updated
            const existingAppContext =
                preferences.user_contexts[0]?.app_context || {}

            const data = {
                lanId,
                env,
                accessToken: accessToken,
                method: MethodConstants.PUT,
                body: {
                    app_id: Constants.APP_ID,
                    user_id: lanId,
                    app_context: [
                        {
                            ...existingAppContext,
                            language,
                            ...(preferredMap !== undefined && {
                                preferredMap,
                            }),
                            ...(landingPage !== undefined && {
                                landingPage,
                            }),
                        },
                    ],
                },
                dynamicSubPath: preferences.user_contexts[0].context_id,
                trackEvent,
            }

            return updateUserContext(data)
        },
    })

    return {
        updatePreferences: mutation.mutate,
        isLoading: mutation.isLoading,
        isError: mutation.isError,
        error: mutation.error,
    }
}
